import { render } from "./CreateNoticeView.vue?vue&type=template&id=dd367a26&scoped=true"
import script from "./CreateNoticeView.vue?vue&type=script&lang=js"
export * from "./CreateNoticeView.vue?vue&type=script&lang=js"

import "./CreateNoticeView.vue?vue&type=style&index=0&id=dd367a26&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd367a26"]])

export default __exports__